import {fromJS} from 'immutable';
import errorActions from '../actions/error.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

export const DEFAULT_STATE = fromJS({
    show: false,
    errorMessage: ''
});

export const errorReducer = (state = DEFAULT_STATE, action) => {
    let newState = state;

    switch (action.type) {
        case errorActions.TYPES.SHOW_ERROR_MESSAGE:
            newState = newState.updateIn(['show'], () => true);
            newState = newState.updateIn(['errorMessage'], () => action.payload.statusMessage);
            return newState;

        case errorActions.TYPES.HIDE_ERROR_MESSAGE:
            newState = fromJS({
                show: false,
                errorMessage: ''
            });
            return newState;

        default:
            return newState;
    }
};

export default dieselReducer('error', errorReducer);
